
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components",
      function () {
        return require("private-next-pages/components.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components"])
      });
    }
  